
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2rhyz_o8jim_32",
  "input": "awsui_input_2rhyz_o8jim_36",
  "input-readonly": "awsui_input-readonly_2rhyz_o8jim_89",
  "input-invalid": "awsui_input-invalid_2rhyz_o8jim_122",
  "input-warning": "awsui_input-warning_2rhyz_o8jim_125",
  "input-type-search": "awsui_input-type-search_2rhyz_o8jim_128",
  "input-has-icon-start": "awsui_input-has-icon-start_2rhyz_o8jim_138",
  "input-has-icon-end": "awsui_input-has-icon-end_2rhyz_o8jim_141",
  "input-container": "awsui_input-container_2rhyz_o8jim_145",
  "input-field": "awsui_input-field_2rhyz_o8jim_150",
  "input-field-readonly": "awsui_input-field-readonly_2rhyz_o8jim_174",
  "input-field-disabled": "awsui_input-field-disabled_2rhyz_o8jim_189",
  "input-field-invalid": "awsui_input-field-invalid_2rhyz_o8jim_197",
  "input-field-warning": "awsui_input-field-warning_2rhyz_o8jim_211",
  "input-field-no-border-radius": "awsui_input-field-no-border-radius_2rhyz_o8jim_225",
  "input-field-no-border": "awsui_input-field-no-border_2rhyz_o8jim_225",
  "grouped": "awsui_grouped_2rhyz_o8jim_240",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_2rhyz_o8jim_250",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_2rhyz_o8jim_254",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_2rhyz_o8jim_260",
  "grouped-vertical-first": "awsui_grouped-vertical-first_2rhyz_o8jim_264",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_2rhyz_o8jim_268",
  "grouped-vertical-last": "awsui_grouped-vertical-last_2rhyz_o8jim_274",
  "grouped-with-action": "awsui_grouped-with-action_2rhyz_o8jim_278",
  "with-error": "awsui_with-error_2rhyz_o8jim_282",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_2rhyz_o8jim_310",
  "grouped-vertical-only": "awsui_grouped-vertical-only_2rhyz_o8jim_310",
  "with-warning": "awsui_with-warning_2rhyz_o8jim_316",
  "grouped-validation-first": "awsui_grouped-validation-first_2rhyz_o8jim_358",
  "input-prefix": "awsui_input-prefix_2rhyz_o8jim_365",
  "input-suffix": "awsui_input-suffix_2rhyz_o8jim_366",
  "input-adornment-content": "awsui_input-adornment-content_2rhyz_o8jim_380",
  "input-adornment-divider": "awsui_input-adornment-divider_2rhyz_o8jim_389",
  "input-icon-start": "awsui_input-icon-start_2rhyz_o8jim_415",
  "input-icon-start-disabled": "awsui_input-icon-start-disabled_2rhyz_o8jim_422",
  "input-icon-end": "awsui_input-icon-end_2rhyz_o8jim_426",
  "input-button-right": "awsui_input-button-right_2rhyz_o8jim_432",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_2rhyz_o8jim_436",
  "inline-label-trigger-wrapper-full-width": "awsui_inline-label-trigger-wrapper-full-width_2rhyz_o8jim_439",
  "inline-label-wrapper": "awsui_inline-label-wrapper_2rhyz_o8jim_443",
  "inline-label-wrapper-full-width": "awsui_inline-label-wrapper-full-width_2rhyz_o8jim_446",
  "inline-label": "awsui_inline-label_2rhyz_o8jim_436",
  "inline-label-disabled": "awsui_inline-label-disabled_2rhyz_o8jim_471"
};
  